/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const inviteUserDataRoleSchema = z.enum(['member', 'admin', 'jobillan', 'recruiter'])

export type InviteUserDataRoleSchema = z.infer<typeof inviteUserDataRoleSchema>
